const formTranslations = {
    title: 'ابدأ التطور الخاص بك',
    descriptionStart: 'ابدأ رحلة تحول جسمك الآن مع',
    informa: 'informa',
    descriptionEnd: '، املأ النموذج للحصول على برنامجك المخصص الآن.',
    actionButton:'التالي',
    backButton:'السابق',
    submitButton:'ارسال'
}

export default formTranslations;